import output from "_src/engine/output";
import { Geometry, GeometryBuffer } from "_src/engine/geometry.js";
import workerManager from "_src/engine/worker_manager.js";
import { messageType } from "_src/engine/ipc.js";
import CortoDecoder from "_src/libs/corto/corto.js";
import { bufferType } from "_src/engine/constants";
import workerPool from "_src/engine/worker_pool";
import arrayTools from "_src/engine/utility/arrays";
import config from "_src/config";

export default class CortoLoader {

  constructor(verbose) {

    this._verbose = verbose;

  }

  _checkVerbosity() {
    return this._verbose;
  }

  loadMain(blob) {
    return new Promise((resolve, reject) => {

      const decoder = new CortoDecoder(blob);

      const messages = [];

      let startTime;
      if (typeof performance !== "undefined") {
        startTime = performance.now();
      }

      decoder.decode().then((result) => {

        if (typeof performance !== "undefined") {
          const decodeEnd = performance.now();
          messages.push("Corto: decoding time: " + ((decodeEnd - startTime) / 1000).toPrecision(3) + " sec.");
        }

        result.messages = messages;

        const geometry = this.prepareGeometry(result);

        if (this._checkVerbosity()) {

          for (let i = 0; i < result.messages.length; ++i) {
            output.log(result.messages[i], output.INDIGO);
          }

        }

        resolve(geometry);

      }).catch((error) => {
        reject(error);
      });
    });
  }

  loadWorker(bufferSource, tid) {

    return new Promise((resolve, reject) => {

      const message = {
        type: messageType.PARSE_CORTO,
        file: bufferSource
      };

      const transfer = [bufferSource];

      workerManager.sendMessage(message, transfer, tid).then(({data}) => {

        const geometry = this.prepareGeometry(data);

        resolve(geometry);

      }).catch((error) => {
        reject(error);
      });

    });

  }

  prepareGeometry(data) {

    const layout = {};

    if (data.position) {

      const posBuffer = data.position.buffer;
      const positionItem = new GeometryBuffer({ buffer : posBuffer, type : bufferType.F32_3 });

      layout["a_position"] = positionItem;

    }

    if (data.normal) {

      const normBuffer = data.normal.buffer;
      const normalItem = new GeometryBuffer({ buffer : normBuffer, type : bufferType.F32_3 });

      layout["a_normal"] = normalItem;

    }

    if (data.uv) {

      const uvBuffer = data.uv.buffer;
      const uvItem = new GeometryBuffer({ buffer : uvBuffer, type : bufferType.F32_2 });
      if (config.viewOnlyMode) {
        uvItem.scheduleUnload();
      }

      layout["a_uv"] = uvItem;

    }

    if (data.colors) {

      const colorBuffer = data.colors.buffer;
      const colorItem = new GeometryBuffer({ buffer : colorBuffer, type : bufferType.F32_3 });
      if (config.viewOnlyMode) {
        colorItem.scheduleUnload();
      }

      layout["a_color"] = colorItem;

    }

    if (data.index) {

      const indicesBuffer = data.index.buffer;
      const indicesType = arrayTools.uintArrayType(data.index, 3);
      const indicesItem = new GeometryBuffer({ buffer : indicesBuffer, type : indicesType });

      layout["indices"] = indicesItem;

    }

    const geometry = new Geometry({
      bbox     : data.bbox,
      layout   : layout,
    });

    return geometry;

  }

  stopLoading() {
    workerManager.terminateByType(messageType.PARSE_CORTO);
  }

  cleanup() {
    workerPool.cleanup(messageType.PARSE_CORTO);
    return Promise.resolve();
  }

}

